<template>
  <div class="DeleteBy" style="width: 300px">
    <div class="flex-center item">
      <div style="width: 100px" class="fs-int-7 title">{{ $l('Deleter') }}</div>
      <div class="flex-1 fs-int">{{ info.handlerName }}</div>
    </div>
    <div class="flex-center item">
      <div style="width: 100px" class="fs-int-7 title">{{ $l('DateTime') }}</div>
      <div class="flex-1 fs-int">{{ getDateToFormatEn(info.createdAt) }}</div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// import { ref, reactive } from 'vue'
import { getDateToFormatEn } from '@/utils/convert'
export default {
  name: 'DeleteBy',

  nameSpace: 'cargoOwner.cargoOrders.allCargoOrders.DeleteBy',

  components: {
  },

  props: {
    info: {
      type: Object,
      default: {}
    }
  },

  setup () {
    return {
      getDateToFormatEn
    }
  }

}
</script>

<style scoped lang="less">
.DeleteBy{
  padding:0;
  .item{
    margin:5px 0;
    .title{
      text-align: right;
      padding-right: @gap;
    }
  }
}
</style>
